import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageHeader from "../components/ui/PageHeader";
import ContractList from "../components/contracts/ContractList";
import ContractForm from "../components/contracts/ContractForm";
import ContractDetail from "../components/contracts/ContractDetail";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";

const ContractsPage = () => {
  const { contractId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingContract, setEditingContract] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleView = (contract) => {
    navigate(`/contracts/${contract.id}`);
  };

  const handleEdit = (contract) => {
    setEditingContract(contract);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingContract(null);
    setRefreshKey((k) => k + 1);
  };

  if (contractId) {
    return <ContractDetail contractId={contractId} onEdit={handleEdit} />;
  }

  return (
    <Box>
      <PageHeader
        title="Contratos"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingContract(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                filter: 'brightness(1.05)',
              },
            }}
          >
            Nuevo Contrato
          </Button>
        }
      />
      <ContractList key={refreshKey} onView={handleView} onEdit={handleEdit} />

      <Dialog
        key={editingContract?.id || "new"}
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setEditingContract(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <ContractForm
            contract={editingContract}
            onSave={handleSave}
            onCancel={() => {
              setShowForm(false);
              setEditingContract(null);
            }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ContractsPage;